/**
 * move contact form into wrapper
 */
(() => {
  const contactForm = document.querySelector('.custom-contact-form');
  const formWrapper = document.querySelector('.contact-form-module .form-section');

  if (contactForm && formWrapper) {
    formWrapper.append(contactForm);
  }
})();
